<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="printOrderList"
	[loading]="!printOrderList"
	[globalFilterFields]="app.keys(printOrderList)"
	[rowHover]="true"
	[rows]="25"
	[showCurrentPageReport]="true"
	[rowsPerPageOptions]="[10, 25, 50]"
	responsiveLayout="scroll"
	[paginator]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Print Orders"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
			<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="refreshPrintJobList()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'arrows-rotate']" size="lg" class="ms-1 me-2"></fa-icon>
					</div>
				</ng-template>
			</p-button>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr style="height: 40px">
			<th pSortableColumn="deviceName">
				<div class="d-flex w-100">
					Station Name
					<p-sortIcon field="deviceName"></p-sortIcon>
					<p-columnFilter
						field="deviceName"
						matchMode="in"
						display="menu"
						[showMatchModes]="false"
						[showOperator]="false"
						[showAddButton]="false"
						class="ml-auto"
					>
						<ng-template pTemplate="header">
							<div class="px-3 pt-3 pb-0">
								<span class="font-bold">Station Name</span>
							</div>
						</ng-template>
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-multiSelect
								[ngModel]="value"
								[options]="kitchenDeviceList"
								optionValue="value"
								optionLabel="label"
								placeholder="Any"
								(onChange)="filter($event.value)"
							>
								<ng-template let-option pTemplate="item">
									<div class="p-multiselect-representative-option">
										<fa-icon [icon]="['far', option.meta]" class="me-2" size="lg"></fa-icon>
										<span class="ml-1">{{ option.label }}</span>
									</div>
								</ng-template>
							</p-multiSelect>
						</ng-template>
					</p-columnFilter>
				</div>
			</th>
			<th pSortableColumn="created">
				<div class="d-flex w-100">
					Order date/time

					<p-sortIcon field="created"></p-sortIcon>
					<p-columnFilter type="date" field="created" display="menu" class="ms-auto"></p-columnFilter>
				</div>
			</th>
			<th pSortableColumn="status">
				<div class="d-flex w-100">
					Job Status

					<p-sortIcon field="status"></p-sortIcon>
					<p-columnFilter type="text" field="status" display="menu" class="ms-auto"></p-columnFilter>
				</div>
			</th>
			<th pSortableColumn="posCheckId">
				<div class="d-flex w-100">
					Check #

					<p-sortIcon field="posCheckId"></p-sortIcon>
					<p-columnFilter type="numeric" field="posCheckId" display="menu" class="ms-auto"></p-columnFilter>
				</div>
			</th>
			<th pSortableColumn="posTableId">
				<div class="d-flex w-100">
					Table
					<p-sortIcon field="posTableId"></p-sortIcon>
					<p-columnFilter type="text" field="posTableId" display="menu" class="ms-auto"></p-columnFilter>
				</div>
			</th>
			<th pSortableColumn="duration">
				<div class="d-flex w-100">
					Ticket Time
					<p-sortIcon field="duration"></p-sortIcon>
					<p-columnFilter type="numeric" field="duration" display="menu" class="ms-auto"></p-columnFilter>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr style="height: 40px" (click)="getPrintOrder(rec.key, rec.printerId)">
			<td>{{ rec.deviceName }}</td>
			<td>{{ app.moment(rec.created).format('l LT') }}</td>
			<td>{{ rec.status }}</td>
			<td>{{ rec.posCheckId }}</td>
			<td>{{ rec.posTableId }}</td>
			<td>{{ rec.duration }} <span *ngIf="rec.duration && rec.duration > 0">&nbsp;min</span></td>
		</tr>
	</ng-template>
</p-table>

<app-kitchen-print-order-record
	*ngIf="printOrderSelected"
	[(printJobItem)]="printJobSelected"
	[(printOrder)]="printOrderSelected"
></app-kitchen-print-order-record>
